<template>
  <div class="content column">
    <div class="center">
      <el-image
        :src="$domain + 'static/noten/website/newHome/index1_title6_img.png'"
        alt="少儿编程"
        style="width: 333px;height: 82px;margin-top: 102px;"
      ></el-image>
    </div>
    <div class="center text">
      关于少儿编程，您是否有如下疑问
    </div>
    <div class="center">
      <el-image
        :src="$domain + 'static/noten/website/newHome/index_box6_img.png'"
        alt="少儿编程"
        style="width: 1200px;height: 700px;margin-top: 90px;"
      ></el-image>
    </div>
    <Test></Test>
  </div>
</template>

<script>
import Test from "@/components/test";
export default {
  components: { Test },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.content {
  height: 1720px;
  .text {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #808080;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/boxList/box4.vue